import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

import initialState from './initialTestDb'
import LoadingSpinner from './components/_reusedcomponents/LoadingSpinner';

/**
 * Automatically generated from the create-react-app. JS file associated with the index.html entry point.
 * Initializes React DOM and the App.js
*/

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
    <React.StrictMode >
            <BrowserRouter basename={baseUrl}>
                <App />
                <LoadingSpinner />
            </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
